module.exports = __webpack_public_path__ + "img/Phone.df8f0ce0.webp";